export const SERVICE_INSPECTION_FORM_ID = 'serviceInspectionForm';
